__turbopack_context__.v({
  "container": "socialProofStrip-module-scss-module__JFv8_G__container",
  "desktopHeadline": "socialProofStrip-module-scss-module__JFv8_G__desktopHeadline",
  "headline": "socialProofStrip-module-scss-module__JFv8_G__headline",
  "iconBefore": "socialProofStrip-module-scss-module__JFv8_G__iconBefore",
  "logo": "socialProofStrip-module-scss-module__JFv8_G__logo",
  "logosContainer": "socialProofStrip-module-scss-module__JFv8_G__logosContainer",
  "mobileHeadline": "socialProofStrip-module-scss-module__JFv8_G__mobileHeadline",
  "socialProofStrip": "socialProofStrip-module-scss-module__JFv8_G__socialProofStrip",
  "stat": "socialProofStrip-module-scss-module__JFv8_G__stat",
  "statDescription": "socialProofStrip-module-scss-module__JFv8_G__statDescription",
  "statDescriptionWrapper": "socialProofStrip-module-scss-module__JFv8_G__statDescriptionWrapper",
  "statIcon": "socialProofStrip-module-scss-module__JFv8_G__statIcon",
  "statItem": "socialProofStrip-module-scss-module__JFv8_G__statItem",
  "statsContainer": "socialProofStrip-module-scss-module__JFv8_G__statsContainer",
});
